<template>
  <section class="main-content">
    <MainBanner :bannerimage="bannerimage" :slides="slides" />
    <script type="application/ld+json">
    {
      "@context": "https://schema.org",
      "@type": "BreadcrumbList",
      "itemListElement": [{
        "@type": "ListItem",
        "position": 1,
        "name": "Startseite - ito consult GmbH",
        "item": "https://ito-consult.de"
      },{
        "@type": "ListItem",
        "position": 2,
        "name": "Über uns",
        "item": "https://ito-consult.de/wir"
      },{
        "@type": "ListItem",
        "position": 3,
        "name": "Partner",
        "item": "https://ito-consult.de/wir/partner"
      },{
        "@type": "ListItem",
        "position": 4,
        "name": "{{partner.title}}",
        "item": "https://ito-consult.de/wir/partner/{{partner.slug}}"
      }]
    }
  </script>
    <section class="block-content pb-5">
        <div class="container my-md-5 py-5">
          <article class="d-content" v-html="partner.full_description"></article>
          <a :href="partner.url" target="_blank" class="btn btn-outline-ito hover-red animated-arrow">
            <svg xmlns="http://www.w3.org/2000/svg" width="20" height="20" fill="currentColor" viewBox="0 0 16 16">
              <path fill-rule="evenodd" d="M4 8a.5.5 0 0 1 .5-.5h5.793L8.146 5.354a.5.5 0 1 1 .708-.708l3 3a.5.5 0 0 1 0 .708l-3 3a.5.5 0 0 1-.708-.708L10.293 8.5H4.5A.5.5 0 0 1 4 8z"/>
            </svg>
            zur Website des Partners
          </a>
        </div>
    </section>
  </section>
</template>

<script>

import axios from 'axios'
import store from '@/store'
import router from '@/router'
const MainBanner = () => import('@/components/Content/MainBanner.vue')

export default {
  name: 'Partner',
  data: function () {
    return {
      partner: null
    }
  },
  computed: {
    partner_slug: function () {
      return this.$route.params.id
    }
  },
  async beforeMount () {
    await axios.get('/business_partner?fields=*.*&filter[slug]=' + this.partner_slug)
      .then(response => {
        if (response.data.data.length > 0) {
          this.partner = response.data.data[0]
          store.commit('loadingStatus', false)
        } else {
          router.replace({ name: '404' })
        }
      })

    // Fallback if User not found
    if (typeof this.partner === 'undefined') {
      this.$parent.singleViewOn = false
      this.$router.push({ name: 'ito.partner' }).catch(() => {})
    }
  },
  components: {
    MainBanner
  }
}
</script>
<style scoped>
    .partner_logo {max-width: 200px;}
    .text_start {text-align: left !important;}
</style>
